import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { Site } from "~/api/Api";
import { apiClient } from "~/api/ApiClient";
import { domainKeys } from "~/components/siteSpeed/queryKeys";
import wizardStyles from "~/components/siteSpeed/wizzard/Wizzard.module.scss";
import { WordpressPluginInstall } from "~/components/siteSpeed/wizzard/WordpressPluginInstall";
import { ALLI_VERIFICATION_NAME } from "~/helpers/consts";

import Button from "../../ui/button/Button";
import { tabs } from "./NewSite";

type NewSiteWordpressInstallProps = {
  site: Site;
  setActiveTab: (tab: string) => void;
};

const NewSiteWordpressInstall = ({
  site,
  setActiveTab,
}: NewSiteWordpressInstallProps) => {
  const navigate = useNavigate();
  const domainId = site.delegated_domain.id;

  const { data: domain } = useQuery({
    queryKey: domainKeys.detail(domainId),
    queryFn: async () => {
      const { data } = await apiClient.domains.domainsDetail(domainId);

      return data?.domain;
    },
    enabled: !!domainId,
  });

  const verificationData =
    domain?.system_config?.filter(
      (record) =>
        typeof record?.[0] === "string" &&
        record[0].startsWith(ALLI_VERIFICATION_NAME),
    ) ?? [];
  const verificationKey = verificationData[0]
    ? String(verificationData[0][3])
    : "";

  const goToStep = (tab: string) => {
    setActiveTab(tab);
    navigate(tab);
  };

  return (
    <div className={wizardStyles.stepSpacing}>
      <WordpressPluginInstall
        verificationKey={verificationKey}
        distinct={domain?.distinct}
        domainName={site.fqdn}
        footer={
          <div className={wizardStyles.stepContentFooter}>
            <Button outlined onClick={() => goToStep(tabs[3])}>
              Back
            </Button>
            <Button onClick={() => goToStep(tabs[5])}>Continue</Button>
          </div>
        }
      />
    </div>
  );
};

export default NewSiteWordpressInstall;
